module.exports = __webpack_public_path__ + "img/lg_ring_g_o_1_0@3x.de8b156c.png";